import { useAppStore } from '@store'

const ProgressBar = () => {
  const { ui } = useAppStore()

  return (
    <div className="fixed top-0 left-0 w-full h-1 bg-dark-800 z-50">
      <div 
        className="h-full bg-gradient-to-r from-primary-500 to-secondary-500 transition-all duration-300 ease-out"
        style={{ width: `${ui.scrollProgress}%` }}
      />
    </div>
  )
}

export default ProgressBar 